import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { motion } from 'framer-motion';

// Contexts
import { AuthProvider } from './contexts/AuthContext';

// Components
import Header from './components/Header';
import BottomNavigation from './components/BottomNavigation';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import SetupWizard from './pages/SetupWizard';
import Home from './pages/Home';
import PlanGenerator from './pages/PlanGenerator';
import GroupVoting from './pages/GroupVoting';
import PlanDetails from './pages/PlanDetails';
import Groups from './pages/Groups';
import Profile from './pages/Profile';


// Styles
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App min-h-screen bg-gradient-to-br from-purple-50 to-blue-50">
          <Routes>
            {/* Public route - Login page */}
            <Route path="/login" element={<Login />} />
            
            {/* Setup Wizard - for new users */}
            <Route path="/setup" element={
              <ProtectedRoute requireSetup={false}>
                <SetupWizard />
              </ProtectedRoute>
            } />
            
            {/* Protected routes - require authentication */}
            <Route path="/" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <motion.main
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 pb-24"
                  >
                    <Home />
                  </motion.main>
                  <BottomNavigation />
                </>
              </ProtectedRoute>
            } />
            
            <Route path="/generate" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <motion.main
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 pb-24"
                  >
                    <PlanGenerator />
                  </motion.main>
                  <BottomNavigation />
                </>
              </ProtectedRoute>
            } />
            

            
            <Route path="/groups" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <motion.main
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 pb-24"
                  >
                    <Groups />
                  </motion.main>
                  <BottomNavigation />
                </>
              </ProtectedRoute>
            } />

            <Route path="/profile" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <motion.main
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 pb-24"
                  >
                    <Profile />
                  </motion.main>
                  <BottomNavigation />
                </>
              </ProtectedRoute>
            } />
            
            <Route path="/group/:groupId" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <motion.main
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 pb-24"
                  >
                    <GroupVoting />
                  </motion.main>
                  <BottomNavigation />
                </>
              </ProtectedRoute>
            } />
            
            <Route path="/plan/:planId" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <motion.main
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 pb-24"
                  >
                    <PlanDetails />
                  </motion.main>
                  <BottomNavigation />
                </>
              </ProtectedRoute>
            } />
          </Routes>
          
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 